import { render, staticRenderFns } from "./CircleCard.vue?vue&type=template&id=37f81bf8&scoped=true&"
import script from "./CircleCard.vue?vue&type=script&lang=js&"
export * from "./CircleCard.vue?vue&type=script&lang=js&"
import style0 from "./CircleCard.vue?vue&type=style&index=0&id=37f81bf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f81bf8",
  null
  
)

export default component.exports